import { gql } from '@apollo/client'

export const RATE_COACH_APPOINTMENT = gql`
  mutation rateCoach($coachUserId: ID!, $appointmentId: ID!, $rating: Int!) {
    rateCoach(coachUserId: $coachUserId, appointmentId: $appointmentId, rating: $rating) {
      success
    }
  }
`
